<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { signature_enabled_default } = currentAccount.value?.settings || {};
    isEnabled.value = !!signature_enabled_default;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.SIGNATURE_DEFAULT.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.SIGNATURE_DEFAULT.API.ERROR'));
  }
};

const toggleSignatureDefault = async () => {
  return updateAccountSettings({
    signature_enabled_default: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.SIGNATURE_DEFAULT.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.SIGNATURE_DEFAULT.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleSignatureDefault" />
      </div>
    </template>
  </SectionLayout>
</template>
